export const routes = [
  {
    path: "/ec2-codex",
    component: () =>
      import(
        /* webpackChunkName: "ec2-codex" */ "./components/Panel.vue"
      ),
    name: "ec2-codex.panel",
    meta: {
      requiresAuth: true,
      requiresFullAdmin: true,
    },
  },
];
